import { SegmentSchema } from '@sondermind/segment';

export interface IDemographicUpdateData {
  personaClientId: number;
  patientInsuranceId: number;
  providerNetworkCompanyId: number;
  hadSuggestedPayer: boolean;
  suggestedPayerId: number;
  accepted?: boolean;
}

export enum AccountEditSegmentEvents {
  DEMOGRAPHIC_UPDATE_SUGGESTIONS_DISPLAYED = 'Demographic Update Suggestions Displayed',
  DEMOGRAPHIC_UPDATE_ACCEPTED = 'Demographic Update Accepted',
}

export interface IAccountEditSegmentSchema extends SegmentSchema {
  [AccountEditSegmentEvents.DEMOGRAPHIC_UPDATE_SUGGESTIONS_DISPLAYED]: IDemographicUpdateData;
  [AccountEditSegmentEvents.DEMOGRAPHIC_UPDATE_ACCEPTED]: IDemographicUpdateData;
}
